import React from 'react'
import { useIsMobile, useIsTablet, useIsDesktop } from 'spa/member/hooks/v2/useScreenSize'
import RegistrationButton from 'spa/member/components/lp/highclass/RegistrationButton'
import SectionTitle from 'spa/member/components/lp/highclass/SectionTitle'
import SectionContainer from 'spa/member/components/lp/highclass/SectionContainer'
import topImage from 'images/lp/member/highclass/top-image-pc.webp'
import topImageTbsp from 'images/lp/member/highclass/top-image-tbsp.webp'
import serviceLogo from 'images/lp/member/highclass/logo.svg'
import serviceAppeal from 'images/lp/member/highclass/service-appeals-pc.svg'
import serviceAppealTb from 'images/lp/member/highclass/service-appeals-tb.svg'
import serviceAppealSp from 'images/lp/member/highclass/service-appeals-sp.svg'
import serviceFeature from 'images/lp/member/highclass/service-features-pc.svg'
import serviceFeatureTbsp from 'images/lp/member/highclass/service-features-tbsp.svg'
import serviceProcess from 'images/lp/member/highclass/service-process-pc.svg'
import serviceProcessTb from 'images/lp/member/highclass/service-process-tb.svg'
import serviceProcessSp from 'images/lp/member/highclass/service-process-sp.svg'
import contractExample1 from 'images/lp/member/highclass/example-1.webp'
import contractExample2 from 'images/lp/member/highclass/example-2.webp'
import contractExample3 from 'images/lp/member/highclass/example-3.webp'
import contractExample4 from 'images/lp/member/highclass/example-4.webp'
import contractExample5 from 'images/lp/member/highclass/example-5.webp'

import styles from './Highclass.module.scss'

export const StyledHighclassLp: React.FC = () => {
  const isMobile = useIsMobile()
  const isTablet = useIsTablet()
  const isDesktop = useIsDesktop()

  return (
    <div className="relative flex flex-col items-center w-full">
      <header className="w-full relative desktop:absolute top-0 left-0 z-10 px-M pt-S pb-0 tablet:py-M">
        <div className="flex items-start">
          <img src={serviceLogo} alt="クラウドワークス テック ハイクラス" className={`text-start ${styles.logo}`} />
        </div>
      </header>
      <div className="absolute top-0 right-0 z-20">
        <div className={`fixed ${styles.fixedButton}`}>
          <RegistrationButton className={styles.button} size="SMALL" />
        </div>
      </div>
      <main className="flex flex-col items-center w-full">
        <img src={isDesktop ? topImage : topImageTbsp } alt="月額報酬上位30％の案件を優先的に紹介" className={`mx-auto w-full h-auto ${styles.topImage}`} />
        <SectionContainer className={`${styles.contractExampleSection}`}>
          <SectionTitle text="契約例" />
          { isTablet ? (
            <>
              <div className={`flex flex-row justify-start items-center px-XS h-auto gap-M mb-M ${styles.tbExampleImagesContainer}`}>
                <div className={styles.exampleImage}><img src={contractExample1} alt="PM補佐" /></div>
                <div className={styles.exampleImage}><img src={contractExample2} alt="SAPモジュールコンサル" /></div>
                <div className={styles.exampleImage}><img src={contractExample3} alt="PMO" /></div>
              </div>
              <div className={`flex flex-row justify-start items-center px-XS h-auto gap-M ${styles.tbExampleImagesContainer}`}>
                <div className={styles.exampleImage}><img src={contractExample4} alt="開発PM" /></div>
                <div className={styles.exampleImage}><img src={contractExample5} alt="BPRコンサルタント" /></div>
              </div>
            </>
          ) : (
            <div className={`flex flex-row justify-start items-center px-XS h-auto ${styles.exampleImagesContainer}`}>
              <div className={styles.exampleImage}><img src={contractExample1} alt="PM補佐" /></div>
              <div className={styles.exampleImage}><img src={contractExample2} alt="SAPモジュールコンサル" /></div>
              <div className={styles.exampleImage}><img src={contractExample3} alt="PMO" /></div>
              <div className={styles.exampleImage}><img src={contractExample4} alt="開発PM" /></div>
              <div className={styles.exampleImage}><img src={contractExample5} alt="BPRコンサルタント" /></div>
            </div>
          )}
        </SectionContainer>
        <section className={`w-full text-center ${styles.serviceAppealContainer}`}>
          <img src={isMobile ? serviceAppealSp : isTablet ? serviceAppealTb : serviceAppeal } alt="求められている人材ならハイクラス専門ジョブアシスタントがあなた専任に" className="mx-auto max-w-full h-auto" />
        </section>
        <SectionContainer className={`px-M ${styles.serviceProcessSection}`}>
          <SectionTitle text="ご利用の流れ" />
          <img src={ isMobile ? serviceProcessSp : isTablet ? serviceProcessTb : serviceProcess } alt="1.登録・書類のご提出、2.お仕事のご紹介、3.書類審査・面談、4.お仕事決定" className="mx-auto max-w-full h-auto mb-4" />
          <div className={`text-center font-semibold ${styles.serviceProcessMessage}`}>
            <p>クラウドワークステックに登録するだけで<br/>案件を優先的に紹介</p>
          </div>
        </SectionContainer>
        <SectionContainer>
          <SectionTitle text="サービスの特徴" />
          <img src={ isDesktop ? serviceFeature : serviceFeatureTbsp } alt="案件比率のグラフ" className="mx-auto max-w-full h-auto mb-4 px-XS" />
        </SectionContainer>
      </main>
      <footer className={`flex flex-col items-center text-center mt-XL tablet:pmt-2XL desktop:mt-3XL mb-3XL tablet:mb-6XL ${styles.footer}`}>
        <img src={serviceLogo} alt="クラウドワークス テック ハイクラス" className={`mt-XL mb-3XL ${styles.footerLogo}`} />
        <RegistrationButton className={styles.footerButton} size="LARGE" />
      </footer>
    </div>
  )
}
